import { Component, inject, OnInit } from '@angular/core';
import { UsersService } from '../users/users.service';
import { GroupService } from './group.service';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Detail, Item, Result } from './group-interface';
import { HelperService } from '../../shared/services/helper.service';
import { ToastService } from '../../shared/services/toast.service';

interface User {
  name: string;
  image: string;
}

interface Group {
  group_id: string;
  name: string;
  type: string;
  link: string;
}

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrl: './groups.component.css',
})
export class GroupsComponent implements OnInit {
  visibleChapter: boolean = false;
  // visibleCluster: boolean = false;
  // visibleFunction: boolean = false;
  users: any[];
  groups!: Group[];
  selectedUsers!: User[];
  chapters: any[] = [];
  clusters: any[] = [];
  functions: any[] = [];
  parentFunction: any[] = [];
  childFunction: any[] = [];
  group: any = {
    group_id: '',
    name: '',
    type: '',
    link: '',
  };

  formGroup: FormGroup;
  private usersService = inject(UsersService);
  private groupService = inject(GroupService);
  private toastService = inject(ToastService);

  private fb = inject(FormBuilder);
  private messageService = inject(MessageService);
  helper = inject(HelperService);
  isLoading: boolean = false;
  isGroupAdded: boolean = false;
  typeForm: any;
  linkForm: any;
  childData: any = [];
  parentGroupArray: any[];
  isGroupLoading: boolean=false;
  isDownloading: boolean = false;

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: [null],
      link: [null],
      type: ['chapter'],
      parent_group_id: [{ value: null, disabled: true }],
      coreMembers: [null, Validators.required],
      spocuser: [null, Validators.required],
      members: [this.selectedUsers, Validators.required],
      viewers: [this.selectedUsers],
      childs: [[]],
    });
    this.usersList();
    this.groupList();
    // Set default selected values
    // this.formGroup.patchValue({
    //   coreMembers: [],
    //   members: [],
    //   viewers: [],
    //   spocuser: [],
    // });
  }

  onSubmit() {
    if (this.formGroup.valid) {
      this.formGroup.getRawValue();
      const formValue = this.formGroup.getRawValue();
      // Perform the desired actions
      const { members, viewers } = this.formGroup.value;
      const formData = {
        group_id: this.group.group_id,
        childs: formValue.childs?.map((group: any) => group.group_id).join(','),
        link: this.group?.link || formValue.link,
        name: this.group?.name || formValue.name,
        parent_group_id:this.isGroupAdded ? formValue?.parent_group_id?.group_id : this.parentFunction[0]?.group_id,
        type: this.group?.type || formValue.type, // Either cluster, function, chapter
        owner: formValue.coreMembers?.user_id,
        // owner: Array.isArray(this.formGroup.value?.coreMembers)
        //   ? this.formGroup.value.coreMembers
        //       .map((item: Detail) => item?.user_id)
        //       .join(',')
        //   : this.formGroup.value?.coreMembers?.user_id || '',
        manager:
          this.group?.type !== 'chapter'
            ? Array.isArray(formValue?.spocuser)
              ? formValue.spocuser
                  .map((item: Detail) => item?.user_id)
                  .join(',')
              : formValue?.spocuser?.user_id || ''
            : '',
        members: formValue?.members
          .map((item: Detail) => item.user_id)
          .join(','),
        viewers:
          formValue?.viewers !== undefined && formValue?.viewers !== null
            ? formValue?.viewers.map((item: Detail) => item.user_id).join(',')
            : '',
      };
      // const themeDataPayload = {payload:this.encodeToBase64(JSON.stringify(formData))};

      if (!this.isGroupAdded) {
        this.groupService.updateGroup(formData).subscribe(
          (data: any) => {
            //const decodedData = this.decodeBase64ToText(data.data);
            try {
              const parsedData = data;
              parsedData.error
                ? this.toastService.error(parsedData.message)
                : this.toastService.success(parsedData.message);
              this.visibleChapter = false;
              this.isGroupAdded = false;
            } catch (error) {
              console.error('Error parsing decoded data:', error);
            }
          },
          (error) => {
            console.error('Error update theme', error);
          }
        );
      } else {
        this.groupService.createGroup(formData).subscribe(
          (data: any) => {
            //const decodedData = this.decodeBase64ToText(data.data);
            try {
              const parsedData = data;
              parsedData.error
                ? this.toastService.error(parsedData.message)
                : this.toastService.success(parsedData.message);
              this.visibleChapter = false;
              this.isGroupAdded = false;
            } catch (error) {
              console.error('Error parsing decoded data:', error);
            }
          },
          (error) => {
            console.error('Error update theme', error);
          }
        );
      }
    }
  }

  onChildGroupSearch(event: any) {
    this.groupList(event.filter);
  }

  usersList(search?: any) {
    this.isLoading = true;
    const userPayload = { start: '0', search };
    this.usersService.getUsers(userPayload).subscribe(
      (data: any) => {
        try {
          this.isLoading = false;
          const parsedData = data;
          this.users = parsedData.data || [];
        } catch (error) {
          this.isLoading = false;
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  searchQuery: string = '';

  onFilterChange(event: any): void {
    this.groupList(this.searchQuery);
  }

  onCoreMemberSearch(event: any) {
    this.usersList(event.filter);
  }

  removeMember(user: any) {
    const currentMembers = this.formGroup.get('members')?.value || [];
    const updatedMembers = currentMembers.filter(
      (member: any) => member.user_id != user.user_id
    );
    this.formGroup.get('members')?.setValue(updatedMembers);
  }

  removeChildGroup(group: any) {
    const currentChilds = this.formGroup.get('childs')?.value || [];
    const updatedMembers = currentChilds.filter(
      (g: any) => g.group_id != group.group_id
    );
    this.formGroup.get('childs')?.setValue(updatedMembers);
  }

  removeViewers(user: any) {
    const currentViewers = this.formGroup.get('viewers')?.value || [];
    const updatedViewers = currentViewers.filter(
      (viewer: any) => viewer.user_id != user.user_id
    );
    this.formGroup.get('viewers')?.setValue(updatedViewers);
  }

  groupList(search?: any) {
    this.isGroupLoading=true
    const groupPayload = {
      type: this.typeForm || 'all',
      link: this.linkForm || 'all',
      search,
    };
    this.groupService.getGroup(groupPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          if (!this.isGroupAdded) {
            this.chapters = parsedData.data?.chapter?.standalone;
            this.clusters = parsedData.data?.cluster?.standalone;
            this.functions = [
              ...parsedData?.data?.function?.standalone,
              ...parsedData.data?.function?.parent,
              ...parsedData.data?.function?.child,
            ];
          }

          if(this.isGroupAdded){
            if (this.typeForm == 'function') {
              this.childData = parsedData.data?.function?.parent || [];
            } else if (this.typeForm == 'cluster') {
              this.childData = parsedData.data?.cluster?.parent || [];
            } else {
              this.childData = parsedData.data?.chapter?.parent || [];
            }
          }
          this.isGroupLoading=false
        } catch (error) {
          this.isGroupLoading=false

          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching groups', error);
      }
    );
  }

  groupParentGroupList(search?: any) {
    const groupPayload = { type: 'all', link: 'parent', search };
    this.groupService.getGroup(groupPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.parentGroupArray = Object.values(parsedData.data).flatMap(
            (category: any) => category.parent
          );
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching groups', error);
      }
    );
  }

  groupDetail(data: any, search?: any) {
    const groupPayload = {
      group_id: data?.group_id,
      type: data?.type,
      link: data?.link,
      search,
    };
    this.groupService.getDetail(groupPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;

          const slectedDropDownListData = this.setDropDownItem(
            parsedData.data.members
          );
          this.users = [
            ...(Array.isArray(slectedDropDownListData?.['owners'])
              ? slectedDropDownListData['owners']
              : []),
            ...(Array.isArray(this.users) ? this.users : []),
            ...(Array.isArray(slectedDropDownListData?.['managers'])
              ? slectedDropDownListData['managers']
              : []),
          ];
          this.users = Array.from(
            new Map(this.users.map((user) => [user.user_id, user])).values()
          );
          // Ensure uniqueness by `user_id`
          if (search?.length < 0 || search == undefined) {
            if (this.group?.type === 'chapter') {
              this.formGroup.patchValue({
                // parent_group_id:parsedData?.data?.parent.parent_functional_director?.detail || null,
                coreMembers: slectedDropDownListData?.['owners']
                  ? slectedDropDownListData['owners'][0]
                  : slectedDropDownListData['owners'][0],
                members: slectedDropDownListData?.['members']
                  ? slectedDropDownListData['members']
                  : [],
                viewers: slectedDropDownListData?.['viewers']
                  ? slectedDropDownListData['viewers']
                  : [],
              });
            } else {
              this.formGroup.patchValue({
                parent_group_id:
                  parsedData?.data?.parent?.parent_functional_director
                    ?.detail || null,
                coreMembers: slectedDropDownListData?.['owners']
                  ? slectedDropDownListData['owners'][0]
                  : [],
                members: slectedDropDownListData?.['members']
                  ? slectedDropDownListData['members']
                  : [],
                spocuser: slectedDropDownListData?.['managers']
                  ? slectedDropDownListData['managers'][0]
                  : [],
                viewers: slectedDropDownListData?.['viewers']
                  ? slectedDropDownListData['viewers'][0] !== null
                    ? slectedDropDownListData['viewers']
                    : []
                  : [],
              });
            }
          }

          if (parsedData.data?.child) {
            this.childFunction = parsedData.data?.child;
          } else {
            this.childFunction = [];
          }
          if (parsedData.data?.parent) {
            this.parentFunction = [parsedData.data?.parent];
          } else {
            this.parentFunction = [];
          }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching groups', error);
      }
    );
  }

  setDropDownItem(data: Item[]): Result {
    return data.reduce<Result>((acc: Result, item: Item) => {
      // Initialize the group if it doesn't exist
      if (!acc[item.place]) {
        acc[item.place] = [];
      }
      // Add the detail object to the correct group
      if (item.detail !== null) {
        acc[item.place].push(item.detail);
      }

      return acc;
    }, {});
  }

  showData(selectedGroup: Group) {
    this.visibleChapter = true;
    const selectGroup = this.groupDetail(selectedGroup);
    this.group = selectedGroup;

    if (this.group?.type !== 'chapter') {
      if (!this.formGroup.contains('spocuser')) {
        this.formGroup.addControl(
          'spocuser',
          this.fb.control(this.selectedUsers, Validators.required)
        );
      }
    } else {
      if (this.formGroup.contains('spocuser')) {
        this.formGroup.removeControl('spocuser');
      }
    }
  }

  linkOptions = [
    { label: 'Standalone', value: 'standalone' },
    { label: 'Child', value: 'child' },
    { label: 'Parent', value: 'parent' },
  ];

  typeOptions = [
    { label: 'Cluster', value: 'cluster' },
    { label: 'Function', value: 'function' },
    { label: 'Chapter', value: 'chapter' },
  ];

  addGroup() {
    this.formGroup.reset(); 
    this.group= {
    name: null,
    type: null,
    link: null,}
    setTimeout(() => {
      this.isGroupAdded = true; 
    });    
    if (this.isGroupAdded) {
      this.formGroup.get('name')?.setValidators([Validators.required]);
      this.formGroup.get('type')?.setValidators([Validators.required]);
      this.formGroup.get('link')?.setValidators([Validators.required]);
      this.formGroup
        .get('parent_group_id')
        ?.setValidators([Validators.required]);

      // ✅ Ensure form state updates
      this.formGroup.get('name')?.updateValueAndValidity();
      this.formGroup.get('type')?.updateValueAndValidity();
      this.formGroup.get('link')?.updateValueAndValidity();
      this.formGroup.get('parent_group_id')?.updateValueAndValidity();
    } else {
      this.formGroup.get('name')?.clearValidators();
      this.formGroup.get('type')?.clearValidators();
      this.formGroup.get('link')?.clearValidators();
      this.formGroup.get('parent_group_id')?.clearValidators();
      this.formGroup.get('childs')?.clearValidators();

      // ✅ Update form state after clearing validators
      this.formGroup.get('name')?.updateValueAndValidity();
      this.formGroup.get('type')?.updateValueAndValidity();
      this.formGroup.get('link')?.updateValueAndValidity();
      this.formGroup.get('parent_group_id')?.updateValueAndValidity();
      this.formGroup.get('childs')?.updateValueAndValidity();
    }

    // this.group = {
    //   group_id: '',
    //   name: '',
    //   type: '',
    //   link: '',
    // };
  }

  onLinkChange() {
    if (this.formGroup.get('link')?.value === 'child') {
      this.groupParentGroupList();
      this.formGroup.get('parent_group_id')?.reset();
      this.formGroup.get('parent_group_id')?.enable();
      this.formGroup
        .get('parent_group_id')
        ?.setValidators([Validators.required]);
    } else {
      this.formGroup.get('parent_group_id')?.disable();
      this.formGroup.get('parent_group_id')?.clearValidators();

      if (this.formGroup.get('link')?.value === 'parent') {
        this.formGroup.get('childs')?.enable();
        this.formGroup.get('childs')?.setValidators([Validators.required]);
      } else {
        this.formGroup.get('childs')?.clearValidators();
      }
      this.formGroup.get('childs')?.updateValueAndValidity();
      this.formGroup.get('parent_group_id')?.updateValueAndValidity();
    }
    if (
      this.formGroup.get('link')?.value === 'parent' &&
      this.formGroup.get('type')?.value
    ) {
      this.formGroup.get('childs')?.reset();
      (this.typeForm = this.formGroup.get('type')?.value),
        (this.linkForm = this.formGroup.get('link')?.value);
      this.groupList();
    }

    this.formGroup.get('parent_group_id')?.updateValueAndValidity();
  }

  onTypeChange() {
    if (this.formGroup.get('link')?.value === 'child') {
      this.formGroup.get('parent_group_id')?.enable();
      this.formGroup
        .get('parent_group_id')
        ?.setValidators([Validators.required]);
    } else {
      this.formGroup.get('parent_group_id')?.disable();
      this.formGroup.get('parent_group_id')?.clearValidators();

      if (
        this.formGroup.get('link')?.value === 'parent' &&
        this.formGroup.get('type')?.value
      ) {
        this.formGroup.get('childs')?.reset();
        (this.typeForm = this.formGroup.get('type')?.value),
          (this.linkForm = this.formGroup.get('link')?.value);
        this.groupList();
      }
    }

    this.formGroup.get('parent_group_id')?.updateValueAndValidity();
  }

  exportGroups() {
    this.isDownloading = true;
    const reqData = {
      responseType: 'blob',
    };

    this.groupService.downloadGroups(reqData).subscribe(
      (data: Blob) => {
        this.isDownloading = false;
        const blob = new Blob([data], { type: data.type });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'groups.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.toastService.success('File downloaded successfully');
      },
      (error) => {
        this.isDownloading = false;
        console.error('Error fetching template:', error);
      }
    );
  }

  updateChapter(form: NgForm) {
    if (form.valid) {
    }
  }

  deleteData() {}
}
